// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ===== FAQ 版面 ===== */
.faq {
  width: 100%;
  display: flex;
}

/* 左側選單（CPA / CMA / EA） */
.faqsubnav {
  /* 別在這裡設超大的字或固定高度，交給子項目控制 */
  text-align: center;
  color: #fff;
  position: relative;
  display: flex;
  flex-direction: column; /* 三塊直向排列 */
}

/* 三塊共同樣式：改用 padding 撐出高度，避免用百分比高度 */
.faqsubnav > div {
  display: flex;
  flex-direction: column; /* 讓 "CPA" 與 "常見問題" 垂直堆疊 */
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px 8px;
  cursor: pointer;
  font-size: 1.5rem; /* 大標（CPA/CMA/EA） */
  line-height: 1.1;
}

/* 副標「常見問題」：強制第二行、縮小字 */
.faqsubnav .fs-2 {
  display: block;
  margin-top: 0.25rem;
  font-size: 1rem !important; /* 覆蓋 bootstrap 的 fs-2 預設值 */
  line-height: 1.2;
  white-space: normal;
}

/* 各塊顏色 */
.faqcpa {
  background-color: #152046;
}

.faqcma {
  background-color: #2B418E;
}

.faqea {
  background-color: #b01b5c;
}

.faqcia {
  background-color: #424242;
}

/* 右側內容區 */
.questionarea {
  width: 100%;
  padding-left: 50px;
  padding-right: 50px;
  font-size: 0.95rem;
}

.question {
  font-size: 1rem; /* ← 你原本寫成 font-style 了，這裡修正成 font-size */
  font-weight: 700;
  width: 100%;
}

/* ===== RWD：手機/平板 ===== */
@media (max-width: 1200px) {
  .faq {
    flex-wrap: wrap;
    justify-content: center;
  }
  /* 左側整欄佔滿寬，內部改成橫排三等分 */
  .faqsubnav {
    width: 100%;
    display: flex;
    flex-direction: row; /* 讓 CPA / CMA / EA 橫向一排 */
  }
  .faqsubnav > div {
    flex: 1 1;
    font-size: 1.1rem; /* 大標再小一點 */
    padding: 16px 4px;
  }
  .faqsubnav .fs-2 {
    font-size: 0.9rem !important; /* 副標再小一點 */
  }
  .questionarea {
    width: 100%;
    padding: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/faq/styles/faq.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,uBAAA;AACA;EACI,WAAA;EACA,aAAA;AAEJ;;AACE,yBAAA;AACA;EACE,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA,EAAA,WAAA;AAEJ;;AACE,oCAAA;AACA;EACE,aAAA;EACA,sBAAA,EAAA,0BAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA,EAAA,mBAAA;EACA,gBAAA;AAEJ;;AACE,uBAAA;AACA;EACE,cAAA;EACA,mBAAA;EACA,0BAAA,EAAA,4BAAA;EACA,gBAAA;EACA,mBAAA;AAEJ;;AACE,SAAA;AACA;EAAU,yBAAA;AAGZ;;AAFE;EAAU,yBAAA;AAMZ;;AALE;EAAU,yBAAA;AASZ;;AARE;EAAW,yBAAA;AAYb;;AAVE,UAAA;AACA;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAaJ;;AAXE;EACE,eAAA,EAAA,yCAAA;EACA,gBAAA;EACA,WAAA;AAcJ;;AAXE,0BAAA;AACA;EACE;IACE,eAAA;IACA,uBAAA;EAcJ;EAXE,sBAAA;EACA;IACE,WAAA;IACA,aAAA;IACA,mBAAA,EAAA,0BAAA;EAaJ;EAXE;IACE,SAAA;IACA,iBAAA,EAAA,WAAA;IACA,iBAAA;EAaJ;EAXE;IACE,4BAAA,EAAA,WAAA;EAaJ;EAVE;IACE,WAAA;IACA,aAAA;EAYJ;AACF","sourcesContent":["/* ===== FAQ 版面 ===== */\n.faq {\n    width: 100%;\n    display: flex;\n  }\n  \n  /* 左側選單（CPA / CMA / EA） */\n  .faqsubnav {\n    /* 別在這裡設超大的字或固定高度，交給子項目控制 */\n    text-align: center;\n    color: #fff;\n    position: relative;\n    display: flex;\n    flex-direction: column; /* 三塊直向排列 */\n  }\n  \n  /* 三塊共同樣式：改用 padding 撐出高度，避免用百分比高度 */\n  .faqsubnav > div {\n    display: flex;\n    flex-direction: column;        /* 讓 \"CPA\" 與 \"常見問題\" 垂直堆疊 */\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    padding: 24px 8px;\n    cursor: pointer;\n    font-size: 1.5rem;             /* 大標（CPA/CMA/EA） */\n    line-height: 1.1;\n  }\n  \n  /* 副標「常見問題」：強制第二行、縮小字 */\n  .faqsubnav .fs-2 {\n    display: block;\n    margin-top: .25rem;\n    font-size: 1rem !important;    /* 覆蓋 bootstrap 的 fs-2 預設值 */\n    line-height: 1.2;\n    white-space: normal;\n  }\n  \n  /* 各塊顏色 */\n  .faqcpa { background-color: #152046; }\n  .faqcma { background-color: #2B418E; }\n  .faqea  { background-color: #b01b5c; }\n  .faqcia  { background-color: #424242; }\n  \n  /* 右側內容區 */\n  .questionarea {\n    width: 100%;\n    padding-left: 50px;\n    padding-right: 50px;\n    font-size: 0.95rem;\n  }\n  .question {\n    font-size: 1rem;               /* ← 你原本寫成 font-style 了，這裡修正成 font-size */\n    font-weight: 700;\n    width: 100%;\n  }\n  \n  /* ===== RWD：手機/平板 ===== */\n  @media (max-width: 1200px) {\n    .faq {\n      flex-wrap: wrap;\n      justify-content: center;\n    }\n  \n    /* 左側整欄佔滿寬，內部改成橫排三等分 */\n    .faqsubnav {\n      width: 100%;\n      display: flex;\n      flex-direction: row;          /* 讓 CPA / CMA / EA 橫向一排 */\n    }\n    .faqsubnav > div {\n      flex: 1 1 0;\n      font-size: 1.1rem;            /* 大標再小一點 */\n      padding: 16px 4px;\n    }\n    .faqsubnav .fs-2 {\n      font-size: .9rem !important;  /* 副標再小一點 */\n    }\n  \n    .questionarea {\n      width: 100%;\n      padding: 16px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
